import styled from 'styled-components';

import { GenericDiv } from 'common/Styles';

export const FilterContainer = styled.div`
    padding-top: 12px;
    background: #FFFFFF;
    box-shadow: none;
    border-radius: 0px;
    display: flex;
    flex-direction: column;
    position: relative;
    top: 0px;
    width: 100%;
`;

export const FilterWrapper = styled(GenericDiv)`
	padding-left: 10px;
	border-left: 2px solid #EDEDED;
	:first-child {
		padding-left: 0px;
		border-left: none;
	}
`;

export const ListWrapper = styled(GenericDiv)`
	list-style-type: disc;
`;
